module.exports = __webpack_public_path__ + "img/desktop5.11f45b6d.svg";